import { render, staticRenderFns } from "./IconYen.vue?vue&type=template&id=1dc4dae8&scoped=true&"
var script = {}
import style0 from "./IconYen.vue?vue&type=style&index=0&id=1dc4dae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4dae8",
  null
  
)

export default component.exports